<template>
  <div class="page cases-page">
    <header class="page-header">
      <h1>应用案例</h1>
      <p>展示 FishROS 在行业落地的典型场景与解决方案。</p>
    </header>
    <div class="case-grid">
      <div class="case-card" v-for="item in cases" :key="item.title">
        <h3>{{ item.title }}</h3>
        <p>{{ item.desc }}</p>
        <div class="tags">
          <span v-for="tag in item.tags" :key="tag">{{ tag }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cases: [
        {
          title: '四足巡检机械狗',
          desc: '面向工业场景的巡检机器人，支持远程监控与自动巡航。',
          tags: ['巡检', '四足', '工业']
        },
        {
          title: '教育机器人实验室',
          desc: '提供课程化教学解决方案，覆盖软硬件一体化训练。',
          tags: ['教育', '课程', '机器人']
        },
        {
          title: '仓储搬运机器人',
          desc: '结合导航与调度系统，实现仓储场景智能搬运。',
          tags: ['仓储', '导航', '调度']
        }
      ]
    }
  }
}
</script>

<style scoped>
.page {
  width: 80%;
  margin: 0 auto;
  padding-bottom: 40px;
}
.page-header {
  background: #fff;
  padding: 24px 28px;
  border-radius: 12px;
  margin-bottom: 24px;
}
.page-header h1 {
  margin: 0 0 8px;
  color: #1f2b5b;
}
.page-header p {
  margin: 0;
  color: #666;
}
.case-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}
.case-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid #ececec;
}
.case-card h3 {
  margin: 0 0 8px;
  color: #1f2b5b;
}
.case-card p {
  margin: 0 0 12px;
  color: #666;
  line-height: 1.6;
}
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.tags span {
  background: #f2f4ff;
  color: #3d5af1;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
}
@media screen and (max-width: 768px) {
  .page {
    width: 90%;
  }
}
</style>
